import { Pipe, PipeTransform } from '@angular/core';

export function statusBadgeNgStyle(row: {
	status_badge_bg?: string | null;
	status_badge_fg?: string | null;
} | null | undefined): Record<string, string> | null {
	if (!row) {
		return null;
	}
	const bg = row.status_badge_bg != null ? String(row.status_badge_bg).trim() : '';
	const fg = row.status_badge_fg != null ? String(row.status_badge_fg).trim() : '';
	if (!bg && !fg) {
		return null;
	}
	const out: Record<string, string> = {};
	if (bg) {
		out['background-color'] = bg;
	}
	if (fg) {
		out['color'] = fg;
	}
	return out;
}

@Pipe({
	name: 'statusBadgeNgStyle',
	pure: true,
})
export class StatusBadgeNgStylePipe implements PipeTransform {
	transform(row: { status_badge_bg?: string | null; status_badge_fg?: string | null } | null | undefined): Record<string, string> | null {
		return statusBadgeNgStyle(row);
	}
}
